/* LauVéA — fiche produit V5 : place le coeur favori en haut à droite de la photo */
(function () {
  var tries = 0;
  function move() {
    var media = document.querySelector('.product__media-wrapper');
    var heart = document.getElementById('wishlist-hero-product-page-button');
    if (!media || !heart) return false;
    var slot = media.querySelector('.lv-heart-slot');
    if (!slot) {
      slot = document.createElement('div');
      slot.className = 'lv-heart-slot';
      media.appendChild(slot);
    }
    if (heart.parentNode !== slot) slot.appendChild(heart);
    return true;
  }
  function loop() {
    if (move() || ++tries > 40) return;
    setTimeout(loop, 250);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loop);
  } else {
    loop();
  }
})();

/* LauVéA — V11 : composeur charms italiens, recadrage automatique des photos.
   - Chaque maillon (neutre, charm, haut de breloque) remplit exactement sa case,
     tous alignés en haut, à la même taille.
   - Breloques : reconnues sur la photo, elles pendent sous le bracelet.
   - Doubles : leurs 2 attaches tombent sur les bons maillons (côte à côte, ou
     avec un maillon libre entre les deux pour les doubles chaînette).
   Si une photo ne peut pas être analysée, elle reste telle quelle.
   Ne touche pas aux photos des fiches ni des collections. */
(function () {
  var root = document.getElementById('lv-ital');
  if (!root || !window.Promise || !window.MutationObserver) return;
  var A = 0.9; /* hauteur / largeur d'un maillon */
  var done = {}, pending = {};

  var st = document.createElement('style');
  st.textContent = '#lv-ital .lvi-slot{height:' + Math.round(52 * A) + 'px}' +
    '#lv-ital .lvi-ov span{height:calc(var(--w,18px)*' + A + ')}' +
    '#lv-ital .lvt{overflow:visible;background:transparent;position:relative;z-index:1}' +
    '#lv-ital .lvt img{pointer-events:none}#lv-ital .lvt-dbl{z-index:2}';
  document.head.appendChild(st);

  function parse(src) {
    var m = src.match(/[?&]width=(\d+)/);
    var w = m ? Number(m[1]) : 240;
    var base = src.replace(/([?&])width=\d+(&?)/, function (a, p, q) { return q ? p : ''; });
    return { base: base, mode: w > 200 ? 'g' : 's' };
  }

  function trim(im, mode) {
    var W = im.naturalWidth, H = im.naturalHeight;
    if (!W || !H) return null;
    var c = document.createElement('canvas'); c.width = W; c.height = H;
    var x = c.getContext('2d'); x.drawImage(im, 0, 0);
    var id = x.getImageData(0, 0, W, H), d = id.data;
    /* couleur du fond = moyenne des 4 coins */
    var k = Math.max(2, Math.round(Math.min(W, H) * 0.03)), r = 0, g = 0, b = 0, a = 0, n = 0;
    [[0, 0], [W - k, 0], [0, H - k], [W - k, H - k]].forEach(function (p) {
      for (var yy = p[1]; yy < p[1] + k; yy++) for (var xx = p[0]; xx < p[0] + k; xx++) {
        var i = (yy * W + xx) * 4; r += d[i]; g += d[i + 1]; b += d[i + 2]; a += d[i + 3]; n++;
      }
    });
    r /= n; g /= n; b /= n; a /= n;
    var transp = a < 128;
    var mask = new Uint8Array(W * H), cols = new Uint32Array(W), rows = new Uint32Array(H), y, X;
    for (y = 0; y < H; y++) for (X = 0; X < W; X++) {
      var j = (y * W + X) * 4, fg;
      if (transp) fg = d[j + 3] > 40;
      else fg = d[j + 3] > 40 && (Math.abs(d[j] - r) + Math.abs(d[j + 1] - g) + Math.abs(d[j + 2] - b)) > 60;
      if (fg) { mask[y * W + X] = 1; cols[X]++; rows[y]++; }
    }
    function span(arr, len, other) {
      var min = Math.max(2, other * 0.015), s = -1, e = -1;
      for (var i = 0; i < len; i++) if (arr[i] >= min) { if (s < 0) s = i; e = i; }
      return [s, e];
    }
    var sx0 = span(cols, W, H), sy0 = span(rows, H, W);
    if (sx0[0] < 0 || sy0[0] < 0) return null;
    var bw = sx0[1] - sx0[0] + 1, bh = sy0[1] - sy0[0] + 1;

    if (mode === 'g') {
      /* grille des charms : carré, charm entier */
      var sw = bw * 1.16, sh = bh * 1.16;
      if (sh < sw) sh = sw; else sw = sh;
      if (sw >= W * 0.95 && sh >= H * 0.95) return null;
      var gx = sx0[0] + bw / 2 - sw / 2, gy = sy0[0] + bh / 2 - sh / 2;
      var og = document.createElement('canvas'); og.width = 240; og.height = 240;
      var gc = og.getContext('2d');
      if (!transp) { gc.fillStyle = 'rgb(' + Math.round(r) + ',' + Math.round(g) + ',' + Math.round(b) + ')'; gc.fillRect(0, 0, 240, 240); }
      var gs = 240 / sw, ax = Math.max(0, gx), ay = Math.max(0, gy), bx = Math.min(W, gx + sw), by = Math.min(H, gy + sh);
      gc.imageSmoothingQuality = 'high';
      gc.drawImage(c, ax, ay, bx - ax, by - ay, (ax - gx) * gs, (ay - gy) * gs, (bx - ax) * gs, (by - ay) * gs);
      return { u: transp ? og.toDataURL('image/png') : og.toDataURL('image/jpeg', 0.9) };
    }

    if (mode.charAt(0) === 'D') return trimGap(c, x, id, d, mask, W, H, sx0, sy0, bh, mode === 'Do' ? 1 : 54 / 52);

    /* bracelet : on repère le maillon (en haut) et ce qui pend dessous */
    var top = sy0[0], bot = sy0[1], minRun = Math.max(2, Math.round(W * 0.01));
    function ext(yy) {
      var L = -1, R = -1;
      for (var xx = sx0[0]; xx <= sx0[1]; xx++) if (mask[yy * W + xx]) { if (L < 0) L = xx; R = xx; }
      return R - L + 1 >= minRun ? [L, R] : null;
    }
    var lim = top + Math.max(2, Math.round(bh * 0.12)), lL = W, lR = -1;
    for (y = top; y < lim; y++) { var e = ext(y); if (e) { if (e[0] < lL) lL = e[0]; if (e[1] > lR) lR = e[1]; } }
    if (lR < 0) return null;
    var linkW = lR - lL + 1, linkB = -1;
    for (y = top + Math.round(linkW * 0.3); y <= bot; y++) {
      var e2 = ext(y);
      if (!e2 || (e2[1] - e2[0] + 1) < linkW * 0.6) { linkB = y; break; }
    }
    var dangle = linkB > 0 && bot - linkB >= linkW * 0.15;
    if (!dangle) { linkB = bot + 1; lL = Math.min(lL, sx0[0]); lR = Math.max(lR, sx0[1]); linkW = lR - lL + 1; }
    var units = (linkB - top) / linkW < 0.62 ? 2 : 1;
    var OW = 156 * units, LH = Math.round(156 * A), sk = OW / linkW;
    var cropX = dangle ? Math.min(lL, sx0[0]) : lL, cropR = dangle ? Math.max(lR + 1, sx0[1] + 1) : lR + 1;
    var dangH = dangle ? Math.round((bot + 1 - linkB) * sk) : 0;
    var outW = Math.round((cropR - cropX) * sk), outH = Math.min(1400, LH + dangH);
    if (dangle) {
      /* autour du maillon et sous lui : le fond devient transparent */
      for (y = top; y <= bot; y++) for (X = 0; X < W; X++) {
        if (mask[y * W + X]) continue;
        if (y >= linkB || X < lL || X > lR) d[(y * W + X) * 4 + 3] = 0;
      }
      x.putImageData(id, 0, 0);
    }
    var o = document.createElement('canvas'); o.width = outW; o.height = outH;
    var ox = o.getContext('2d');
    ox.imageSmoothingQuality = 'high';
    ox.drawImage(c, cropX, top, cropR - cropX, linkB - top, 0, 0, outW, LH);
    if (dangle) ox.drawImage(c, cropX, linkB, cropR - cropX, bot + 1 - linkB, 0, LH, outW, outH - LH);
    return {
      u: (dangle || transp) ? o.toDataURL('image/png') : o.toDataURL('image/jpeg', 0.9),
      wp: (cropR - cropX) / linkW * 100, ml: -(lL - cropX) / linkW * 100,
      ar: outH / outW, units: units, dangle: dangle
    };
  }

  /* double chaînette : 2 attaches, un maillon libre entre les deux, la chaînette pend dessous */
  function trimGap(c, x, id, d, mask, W, H, sx0, sy0, bh, P) {
    var top = sy0[0], bot = sy0[1], minRun = Math.max(2, Math.round(W * 0.01)), X, y;
    var band = top + Math.max(3, Math.round(bh * 0.15)), hit = new Uint8Array(W), runs = [], s = -1;
    for (y = top; y < band; y++) for (X = sx0[0]; X <= sx0[1]; X++) if (mask[y * W + X]) hit[X] = 1;
    for (X = sx0[0]; X <= sx0[1] + 1; X++) {
      var on = X <= sx0[1] && hit[X];
      if (on && s < 0) s = X;
      if (!on && s >= 0) { if (X - s >= minRun) runs.push([s, X - 1]); s = -1; }
    }
    if (runs.length < 2) return null;
    var aL = runs[0][0], aR = runs[0][1], bL = runs[runs.length - 1][0], bR = runs[runs.length - 1][1];
    var eW = aR - aL + 1, linkB = -1;
    for (y = top + Math.round(eW * 0.3); y <= bot; y++) {
      var cnt = 0;
      for (X = aL; X <= aR; X++) if (mask[y * W + X]) cnt++;
      if (cnt < eW * 0.6) { linkB = y; break; }
    }
    if (linkB < 0) linkB = Math.min(bot + 1, top + Math.round(eW * A));
    for (y = top; y <= bot; y++) for (X = 0; X < W; X++) {
      if (mask[y * W + X]) continue;
      var inEnd = y < linkB && ((X >= aL && X <= aR) || (X >= bL && X <= bR));
      if (!inEnd) d[(y * W + X) * 4 + 3] = 0;
    }
    x.putImageData(id, 0, 0);
    var SW = 156, LH = Math.round(SW * A), k = SW / eW, m1 = Math.round(SW * 2 * P), outW = m1 + SW;
    var hang = Math.max(0, Math.round((bot + 1 - linkB) * k)), outH = Math.min(1400, LH + hang);
    var o = document.createElement('canvas'); o.width = outW; o.height = outH;
    var ox = o.getContext('2d'); ox.imageSmoothingQuality = 'high';
    var colsSrc = [[aL, aR + 1], [aR + 1, bL], [bL, bR + 1]], colsDst = [[0, SW], [SW, m1], [m1, outW]];
    for (var i = 0; i < 3; i++) {
      var sw = colsSrc[i][1] - colsSrc[i][0], dw = colsDst[i][1] - colsDst[i][0];
      if (sw <= 0 || dw <= 0) continue;
      ox.drawImage(c, colsSrc[i][0], top, sw, linkB - top, colsDst[i][0], 0, dw, LH);
      if (hang > 0) ox.drawImage(c, colsSrc[i][0], linkB, sw, bot + 1 - linkB, colsDst[i][0], LH, dw, outH - LH);
    }
    return { u: o.toDataURL('image/png'), wp: outW / SW * 100, ml: 0, ar: outH / outW, units: 1, dangle: true, dbl: true };
  }

  function crop(info) {
    return new Promise(function (res) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () { try { res(trim(im, info.mode)); } catch (e) { res(null); } };
      im.onerror = function () { res(null); };
      im.src = info.base + (info.base.indexOf('?') > -1 ? '&' : '?') + 'width=480&lvtrim=1';
    });
  }

  function over(img) {
    var p = img.parentNode;
    return p.clientWidth * Number(img.dataset.lvtwp) / 100 * Number(img.dataset.lvtar) - p.clientHeight;
  }

  function show(img, v) {
    img.src = v.u;
    if (!v.ar) return;
    var p = img.parentNode;
    p.classList.add('lvt');
    var pair = p.getAttribute('data-dbl') === '0';
    if (v.dbl) p.classList.add('lvt-dbl');
    if (pair && !v.dbl) {
      /* double côte à côte : l'image couvre ses 2 maillons */
      var P = p.tagName === 'SPAN' ? 1 : 54 / 52;
      v = { u: v.u, wp: v.wp * (1 + P), ml: v.ml * (1 + P), ar: v.ar, units: 1, dangle: v.dangle };
      p.classList.add('lvt-dbl');
    } else if (v.units === 2 && !pair) {
      p.style.width = p.tagName === 'SPAN' ? 'calc(var(--w,18px)*2)' : '104px'; p.dataset.lvtu = 2;
    }
    img.dataset.lvtwp = v.wp; img.dataset.lvtar = v.ar;
    img.style.cssText = 'width:' + v.wp + '%;max-width:none;height:auto;margin-left:' + v.ml + '%;object-fit:fill;border-radius:0;display:block';
    var num = p.querySelector('.lvi-n');
    if (num && v.dangle && !v.dbl) num.style.bottom = -(Math.max(0, over(img)) + 14) + 'px';
    schedulePad();
  }

  var padT;
  function schedulePad() { clearTimeout(padT); padT = setTimeout(fixPad, 0); }
  function fixPad() {
    /* l'aperçu du haut tient en largeur même avec des doubles */
    var ov = root.querySelector('.lvi-ov');
    if (ov) {
      var sp = ov.children, tot = 0, dbl = false;
      for (var q = 0; q < sp.length; q++) { var u = Number(sp[q].dataset.lvtu || 1); tot += u; if (u > 1) dbl = true; }
      if (dbl && tot) ov.style.setProperty('--w', Math.max(8, Math.floor(((root.clientWidth || 340) - 24) / tot)) + 'px');
    }
    [['.lvi-strip', 16], ['.lvi-ov', 0]].forEach(function (z) {
      var box = root.querySelector(z[0]); if (!box) return;
      var m = 0, l = box.querySelectorAll('.lvt img');
      for (var i = 0; i < l.length; i++) { var o = over(l[i]); if (o > m) m = o; }
      box.style.paddingBottom = m > 0 ? (z[1] + Math.ceil(m)) + 'px' : '';
    });
  }

  function apply(img) {
    var src = img.getAttribute('src');
    if (!src || src.indexOf('data:') === 0) return;
    var info = parse(src), p = img.parentNode, db = p && p.getAttribute ? p.getAttribute('data-dbl') : null;
    if (db === '1') { p.classList.add('lvt'); img.style.visibility = 'hidden'; return; }
    if (db === '0' && info.mode === 's' && p.getAttribute('data-gap') === '2') info.mode = p.tagName === 'SPAN' ? 'Do' : 'Ds';
    var key = info.base + '|' + info.mode;
    if (key in done) { if (done[key]) show(img, done[key]); return; }
    if (!pending[key]) pending[key] = crop(info).then(function (v) { done[key] = v; return v; });
    pending[key].then(function (v) { if (v && img.getAttribute('src') === src) show(img, v); });
  }

  function scan(node) {
    if (node.nodeType !== 1) return;
    if (node.tagName === 'IMG') { apply(node); return; }
    var l = node.querySelectorAll('img');
    for (var i = 0; i < l.length; i++) apply(l[i]);
  }

  new MutationObserver(function (ms) {
    ms.forEach(function (m) { for (var i = 0; i < m.addedNodes.length; i++) scan(m.addedNodes[i]); });
    schedulePad();
  }).observe(root, { childList: true, subtree: true });
  window.addEventListener('resize', schedulePad);
  scan(root);
})();
